import { render, staticRenderFns } from "./Json.vue?vue&type=template&id=2841da9d&scoped=true"
import script from "./Json.vue?vue&type=script&lang=js"
export * from "./Json.vue?vue&type=script&lang=js"
import style0 from "./Json.vue?vue&type=style&index=0&id=2841da9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841da9d",
  null
  
)

export default component.exports